







import XInput from 'vux/src/components/x-input/index.vue'

export default {
name: "chatframe",
components: {
XInput,
},
props: {
values:String,
itemValue:String,









},
data() {
return {
value:this.values
}
},
mounted() {
this.$emit("onTheryInput",this.value)
},
beforeDestroy() {

},
methods:{

onDelOneInput()
{
this.$emit("onDelThrryInput",2)
},
},
watch:{
value(value)
{
this.$emit("onTheryInput",value)
},
values(val)
{

console.log('%c⧭', 'color: #00736b', val)
this.value = val;
this.$emit("onTheryInput",val)
},
itemValue(val)
{

console.log('%c⧭', 'color: #cc7033', val,"---")
this.value = val;
this.$emit("onTheryInput",val)
}
}
}



// WEBPACK FOOTER //
// ./src/myComponents/theryInput/theryInput.vue